const API_URL = "https://orendion-bend.onrender.com";

export default API_URL;
